import { render, staticRenderFns } from "./POrderModal.vue?vue&type=template&id=c0e04e5c&"
import script from "./POrderModal.vue?vue&type=script&lang=js&"
export * from "./POrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports